import React, { Component } from 'react';

export class AirlineMaster extends Component {
    constructor(props) {
        super(props);
        this.state = { list: [], loading: true, search: '', editItem: null, form: { name:'', desc:'', logo:'' }, uploading: false };
    }

    componentDidMount() { this.load(); }

    load() {
        this.setState({ loading: true });
        fetch('api/programplus/airlines/master')
            .then(r => r.ok ? r.json() : [])
            .then(list => this.setState({ list, loading: false }))
            .catch(() => this.setState({ loading: false }));
    }

    openAdd() { this.setState({ editItem: { id: 0 }, form: { name:'', desc:'', logo:'' } }); }
    openEdit(item) { this.setState({ editItem: item, form: { name:item.name||'', desc:item.desc||'', logo:item.logo||'' } }); }
    closeModal() { this.setState({ editItem: null }); }

    upd(field, val) { this.setState({ form: { ...this.state.form, [field]: val } }); }

    async uploadLogo() {
        var input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.onchange = async (e) => {
            if (!e.target.files[0]) return;
            this.setState({ uploading: true });
            var fd = new FormData();
            fd.append('file', e.target.files[0]);
            fd.append('folder', 'Airline');
            try {
                var r = await fetch('api/programplus/upload', { method: 'POST', body: fd });
                var res = await r.json();
                this.upd('logo', res.path);
            } catch {}
            this.setState({ uploading: false });
        };
        input.click();
    }

    async save() {
        var { form, editItem } = this.state;
        if (!form.name.trim()) { alert('กรุณากรอกชื่อสายการบิน'); return; }
        var body = { id: editItem.id || 0, name: form.name.trim(), desc: form.desc.trim(), logo: form.logo };
        try {
            var r = await fetch('api/programplus/airlines/master', {
                method:'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify(body)
            });
            if (!r.ok) throw new Error('save failed');
            this.closeModal();
            this.load();
        } catch (e) { alert('บันทึกไม่สำเร็จ: ' + e.message); }
    }

    async del(item) {
        if (!window.confirm('ต้องการลบ "' + item.name + '" หรือไม่?')) return;
        try {
            var r = await fetch('api/programplus/airlines/master/' + item.id, { method: 'DELETE' });
            if (!r.ok) throw new Error('delete failed');
            this.load();
        } catch (e) { alert('ลบไม่สำเร็จ: ' + e.message); }
    }

    getFiltered() {
        var { list, search } = this.state;
        if (!search.trim()) return list;
        var s = search.trim().toLowerCase();
        return list.filter(x => (x.name||'').toLowerCase().includes(s) || (x.desc||'').toLowerCase().includes(s));
    }

    render() {
        var { loading, search, editItem, form, uploading } = this.state;
        var filtered = this.getFiltered();

        return (
            <div style={{ padding: 20 }}>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <p style={{ margin: 0, fontSize: 13, color: '#888' }}>ทั้งหมด {filtered.length} รายการ</p>
                    <button className="btn btn-danger" onClick={() => this.openAdd()}><i className="fas fa-plus"></i> เพิ่มสายการบิน</button>
                </div>

                <div style={{ background:'#fff', borderRadius:10, padding:14, boxShadow:'0 2px 12px rgba(0,0,0,0.06)', marginBottom:16 }}>
                    <div className="input-group" style={{ maxWidth:400 }}>
                        <span className="input-group-text" style={{ background:'#fff' }}><i className="fas fa-search" style={{ color:'#aaa' }}></i></span>
                        <input className="form-control" placeholder="ค้นหาชื่อสายการบิน..." value={search} onChange={e=>this.setState({search:e.target.value})} style={{ borderLeft:'none' }} />
                    </div>
                </div>

                {loading ? (
                    <div className="text-center py-5"><div className="spinner-border text-danger"></div></div>
                ) : filtered.length === 0 ? (
                    <div className="text-center py-5" style={{ color:'#bbb' }}>
                        <i className="fas fa-inbox" style={{ fontSize:48, display:'block', marginBottom:12 }}></i>
                        {search ? 'ไม่พบรายการ' : 'ยังไม่มีสายการบิน'}
                    </div>
                ) : (
                    <div className="row">
                        {filtered.map(a => (
                            <div key={a.id} className="col-md-6 col-lg-4 mb-3">
                                <div style={{ background:'#fff', borderRadius:10, padding:16, boxShadow:'0 2px 12px rgba(0,0,0,0.06)', display:'flex', alignItems:'center', gap:14 }}>
                                    <div style={{ width:80, height:60, borderRadius:8, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, overflow:'hidden', background: a.logo ? '#fafafa' : 'linear-gradient(135deg,#fff 0%, #f3f3f3 100%)', border: a.logo ? 'none' : '2px dashed #ddd' }}>
                                        {a.logo ? <img src={a.logo} alt="" style={{ maxWidth:'100%', maxHeight:'100%', objectFit:'contain' }} /> : <i className="fas fa-plane" style={{ fontSize:26, color:'#bbb' }}></i>}
                                    </div>
                                    <div style={{ flex:1, minWidth:0 }}>
                                        <div style={{ fontSize:14, fontWeight:700 }}>{a.name}</div>
                                        {a.desc && <div style={{ fontSize:12, color:'#888', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{a.desc}</div>}
                                    </div>
                                    <div className="d-inline-flex" style={{ gap:8 }}>
                                        <button className="btn btn-sm btn-outline-primary" onClick={() => this.openEdit(a)}><i className="fas fa-edit"></i></button>
                                        <button className="btn btn-sm btn-outline-danger" onClick={() => this.del(a)}><i className="fas fa-trash"></i></button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {editItem && (
                    <div style={{ position:'fixed', top:0, left:0, right:0, bottom:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }} onClick={() => this.closeModal()}>
                        <div style={{ background:'#fff', borderRadius:12, padding:24, width:'90%', maxWidth:500 }} onClick={e => e.stopPropagation()}>
                            <h5 style={{ marginBottom:16 }}>{editItem.id ? 'แก้ไข' : 'เพิ่ม'}สายการบิน</h5>

                            <div className="mb-3">
                                <label style={{ fontSize:13, fontWeight:600 }}>โลโก้</label>
                                <div onClick={() => this.uploadLogo()} style={{ width:'100%', height:120, border:'2px dashed #ccc', borderRadius:8, cursor:'pointer', overflow:'hidden', display:'flex', alignItems:'center', justifyContent:'center', background:'#fafafa' }}>
                                    {form.logo ? <img src={form.logo} alt="" style={{ maxWidth:'100%', maxHeight:'100%', objectFit:'contain' }} /> : (
                                        <div style={{ textAlign:'center', color:'#999' }}>
                                            <i className="fas fa-cloud-upload-alt fa-2x"></i>
                                            <div style={{ marginTop:6, fontSize:12 }}>{uploading ? 'กำลังอัปโหลด...' : 'คลิกเพื่ออัปโหลดโลโก้'}</div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="mb-3">
                                <label style={{ fontSize:13, fontWeight:600 }}>ชื่อสายการบิน *</label>
                                <input className="form-control" placeholder="เช่น Thai Airways" value={form.name} onChange={e=>this.upd('name', e.target.value)} autoFocus />
                            </div>

                            <div className="mb-3">
                                <label style={{ fontSize:13, fontWeight:600 }}>คำอธิบาย</label>
                                <input className="form-control" placeholder="เช่น การบินไทย (Thai Airways)" value={form.desc} onChange={e=>this.upd('desc', e.target.value)} />
                            </div>

                            <div className="d-flex justify-content-end" style={{ gap:8 }}>
                                <button className="btn btn-outline-secondary" onClick={() => this.closeModal()}>ยกเลิก</button>
                                <button className="btn btn-danger" onClick={() => this.save()}><i className="fas fa-save"></i> บันทึก</button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
